import { c as _c } from "react/compiler-runtime";
import type { FC, PropsWithChildren } from "react";
import { faXmark } from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "../../widgets";
import Portal from "../Portal";
import { usePopup } from "./usePopup";
import "./styles.scss";
const Popup: FC<PropsWithChildren> = () => {
  const $ = _c(24);
  const {
    isOpen,
    props,
    onClose
  } = usePopup();
  const t0 = `12px solid ${props?.color}`;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      borderLeft: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = props?.icon && <Icon icon={props.icon} style={{
      color: props?.color
    }} />;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="popup__icon">{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props) {
    t4 = props?.title && <h4>{props.title}</h4>;
    $[6] = props;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== props?.message) {
    t5 = props?.message.split("\n").map(_temp);
    $[8] = props?.message;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="popup__content">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Icon icon={faXmark} />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== onClose) {
    t8 = <div><button className="popup__close" onClick={onClose} aria-label="Close popup" type="button">{t7}</button></div>;
    $[14] = onClose;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t1 || $[17] !== t3 || $[18] !== t6 || $[19] !== t8) {
    t9 = <dialog open={true} style={t1} className="popup">{t3}{t6}{t8}</dialog>;
    $[16] = t1;
    $[17] = t3;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== isOpen || $[22] !== t9) {
    t10 = <Portal isOpen={isOpen}>{t9}</Portal>;
    $[21] = isOpen;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
};
export default Popup;
function _temp(line, i) {
  return <p key={i}>{line}</p>;
}